export default __webpack_public_path__ + "static/media/locationtypeicon.8864a365.svg";